/* eslint-disable max-classes-per-file */

import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IDeliveryAddressRequest } from '../../models/delivery-addresses/delivery-address.model';

export class LoadDeliveryAddresses {
  static readonly type = '[DeliveryAddresses] Load DeliveryAddresses via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadDeliveryAddressById {
  static readonly type = '[DeliveryAddresses] Load DeliveryAddress By Id via Service';
  constructor(public id: string) {}
}

export class CreateDeliveryAddress {
  static readonly type = '[DeliveryAddresses] Create DeliveryAddress';
  constructor(public deliveryAddress: IDeliveryAddressRequest) {}
}

export class UpdateDeliveryAddress {
  static readonly type = '[DeliveryAddresses] Update DeliveryAddress';
  constructor(public deliveryAddress: IDeliveryAddressRequest) {}
}

export class DeleteDeliveryAddress {
  static readonly type = '[DeliveryAddresses] Delete DeliveryAddress';
  constructor(public deliveryAddressId: string) {}
}

export class ClearCurrentDeliveryAddress {
  static readonly type = '[DeliveryAddresses] Clear Current DeliveryAddress';
}

export class LoadDeliveryAddressList {
  static readonly type = '[DeliveryAddresses] Load DeliveryAddress List via Service';
  constructor(public departmentId?: string) {}
}
